import { combineReducers } from 'redux'
// import { reducer as reduxForm } from 'redux-form'

import userReducer from './userReducer'
import listReducer from './listReducer'
import postReducer from './postReducer'
import filterReducer from './filterReducer'
import detailsReducer from './detailsReducer'
import pushReducer from './pushReducer'
import chatReducer from './chatReducer'
import activeChatReducer from './activeChatReducer'
import toastReducer from './toastReducer'

const rootReducer = combineReducers({
  user: userReducer,
  list: listReducer,
  post: postReducer,
  filter: filterReducer,
  activeDetails: detailsReducer,
  push: pushReducer,
  chat: chatReducer,
  activeChat: activeChatReducer,
  toast: toastReducer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js